'use strict';

wbApp.directive('wbColorPicker', ['$timeout', '$translate',
    function ($timeout, $translate) {

        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1,
            scope: { ngModel: '=' },
            template: '<div style="width: 100%; height: 100%; padding: 1px;" type="button" data-template="directives-color-picker.html" data-animation="am-flip-x"  data-placement="bottom" bs-popover></div>',
            link: function (scope, elm, attrs, ctrl) {
                scope.onColorClick = function (e) {
                    var color = $(e.target).css("background-color");
                    if (color) {
                        ctrl.$setViewValue(color, e);
                        ctrl.$render();
                    }
                }

                ctrl.$parsers.unshift(function (viewValue) {
                    if (!viewValue) {
                        return 0;
                    } else {
                        var colorUtils = new webooker_utils.ColorUtils();

                        return colorUtils.rgbToInt(viewValue);
                    }
                });

                ctrl.$formatters.unshift(function (value) {
                    var colorUtils = new webooker_utils.ColorUtils();

                    if (!value) {
                        return colorUtils.intToRgb(0);
                    } else {
                        return colorUtils.intToRgb(value);
                    }
                });

                ctrl.$render = function () {
                    elm.children().css('background-color', ctrl.$viewValue);
                };
            }
        }
    }]);
